import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
const T = (k, params) => {
  const locale = app.translator && app.translator.locale || 'zh-Hans';
  const zh = {
    poll_title: '投票',
    poll_vote: '投票',
    poll_voted: '已投',
    poll_total: '{count} 人参与',
    poll_expired_label: '已截止'
  };
  const en = {
    poll_title: 'Poll',
    poll_vote: 'Vote',
    poll_voted: 'Voted',
    poll_total: '{count} votes',
    poll_expired_label: 'Closed'
  };
  const pack = locale === 'en' ? en : zh;
  let s = pack[k] || zh[k];
  if (params) s = s.replace('{count}', params.count);
  return s;
};

/**
 * 投票组件：按 scope(site/tag/discussion) 拉取并渲染，可投票/查看结果。
 */
export default class PollBox extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.loading = true;
    this.polls = [];
    this.selections = {}; // pollId -> [optionIds]
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    try {
      this.load();
    } catch (e) {
      this.loading = false;
      this.polls = [];
    }
  }
  apiUrl() {
    return app.forum.attribute('apiUrl');
  }
  query() {
    const a = this.attrs;
    let q = `scope=${a.scope}`;
    if (a.scope === 'discussion' && a.discussionId) q += `&discussion_id=${a.discussionId}`;
    if (a.scope === 'tag' && a.tagId) q += `&tag_id=${a.tagId}`;
    return q;
  }
  load() {
    this.loading = true;
    app.request({
      method: 'GET',
      url: `${this.apiUrl()}/kapok-polls?${this.query()}`,
      deserialize: JSON.parse
    }).then(res => {
      this.polls = res && res.items || [];
    }).catch(() => {
      this.polls = [];
    }).then(() => {
      this.loading = false;
      // 推迟到下一个 tick，避免在首次 mount 期间重入 mithril 导致整棵树损坏
      setTimeout(() => m.redraw(), 0);
    });
  }
  toggle(poll, optionId) {
    const cur = new Set(this.selections[poll.id] || []);
    if (poll.multiple) {
      cur.has(optionId) ? cur.delete(optionId) : cur.add(optionId);
    } else {
      cur.clear();
      cur.add(optionId);
    }
    this.selections[poll.id] = Array.from(cur);
  }
  vote(poll) {
    const ids = this.selections[poll.id] || [];
    if (!ids.length) return;
    app.request({
      method: 'POST',
      url: `${this.apiUrl()}/kapok-polls/${poll.id}/vote`,
      body: {
        option_ids: ids
      },
      deserialize: JSON.parse
    }).then(() => this.load()).catch(() => {});
  }
  view() {
    // 兜底：任何渲染异常都不能打断整棵树的 mount
    try {
      return this.renderInner();
    } catch (e) {
      return m("div", {
        className: "KapokPoll"
      }, "\u6295\u7968\u6682\u4E0D\u53EF\u7528");
    }
  }
  renderInner() {
    if (this.loading) {
      return m("div", {
        className: "KapokPoll KapokPoll-loading"
      }, "\u52A0\u8F7D\u4E2D\u2026");
    }
    if (!this.polls.length) return null;
    return m("div", {
      className: "KapokPoll"
    }, this.polls.map(poll => {
      const voted = poll.myVotes && poll.myVotes.length > 0;
      const sel = this.selections[poll.id] || [];
      return m("div", {
        className: "KapokPoll-item",
        key: poll.id
      }, m("div", {
        className: "KapokPoll-title"
      }, T('poll_title'), " \xB7 ", poll.title, poll.expired ? m("span", {
        className: "KapokPoll-expired"
      }, T('poll_expired_label')) : null), m("div", {
        className: "KapokPoll-options"
      }, poll.options.map(opt => {
        const isMine = poll.myVotes.includes(opt.id);
        if (voted || poll.expired) {
          return m("div", {
            className: "KapokPoll-bar",
            key: opt.id
          }, m("div", {
            className: "KapokPoll-barFill",
            style: `width:${opt.percent}%`
          }), m("span", {
            className: "KapokPoll-barText"
          }, isMine ? '✓ ' : '', opt.text, " \xB7 ", opt.percent, "%"));
        }
        return m("label", {
          className: "KapokPoll-opt",
          key: opt.id
        }, m("input", {
          type: poll.multiple ? 'checkbox' : 'radio',
          name: `poll-${poll.id}`,
          checked: sel.includes(opt.id),
          onchange: () => this.toggle(poll, opt.id)
        }), m("span", null, opt.text));
      })), m("div", {
        className: "KapokPoll-foot"
      }, m("span", null, T('poll_total', {
        count: poll.totalVotes
      })), !voted && !poll.expired ? m(Button, {
        className: "Button Button--primary Button--small",
        onclick: () => this.vote(poll)
      }, T('poll_vote')) : m("span", {
        className: "KapokPoll-voted"
      }, T('poll_voted'))));
    }));
  }
}
flarum.reg.add('kapok-plus-site', 'forum/components/PollBox', PollBox);